import { defineComponent as n, createBlock as t, openBlock as a, unref as c, mergeProps as l, withCtx as p, createElementVNode as u } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconCurrencyEuro",
  __name: "IconCurrencyEuro",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const o = r;
    return (m, e) => (a(), t(c(i), l(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        u("path", {
          "fill-rule": "evenodd",
          d: "M6.909 9.75c1.306-4.706 6.65-7.386 11.874-5.257a.75.75 0 1 1-.566 1.389c-4.293-1.75-8.475.307-9.73 3.868h6.643a.75.75 0 0 1 0 1.5H8.147a6.962 6.962 0 0 0 0 1.5h6.983a.75.75 0 0 1 0 1.5H8.484c1.253 3.572 5.436 5.616 9.733 3.866a.75.75 0 1 1 .566 1.389C13.559 21.634 8.212 18.97 6.907 14.25H5.5a.75.75 0 0 1 0-1.5h1.14a8.754 8.754 0 0 1 0-1.5H5.5a.75.75 0 0 1 0-1.5h1.409",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
